import script from "./email-work-order-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./email-work-order-modal.vue?vue&type=script&setup=true&lang=ts"

import "./email-work-order-modal.vue?vue&type=style&index=0&id=34548c74&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34548c74"]])

export default __exports__